import React from 'react'
import { connect } from 'react-redux'

import styles from './GameSummary.module.css'

const GameSummary = props => {
  return (
    <React.Fragment>
      <h2 className={styles.title}>Game Summary</h2>
      <div className={styles.gameSummary}>
        <div className={styles.summaryItem}>
          <h1 className={styles.message}>You { props.status === 'finished' ? 'Win!!!' : 'Lose...'}</h1>
        </div>
        <div className={styles.summaryItem}>
          <p>The phrase is:</p>
          <h3><em>" {props.solution} "</em></h3>
        </div>
        <div className={styles.summaryItem}>
          <p>Number of correct letters:</p>
          <h3>{props.correctGuessesCount}</h3>
        </div>
        <div className={styles.summaryItem}>
          <p>Number of incorrect letters:</p>
          <h3>{props.incorrectGuessesCount}</h3>
        </div>
        <div className={styles.buttons}>
          <a href="/play" onClick={props.clicked}>Play Again</a>
          <a href="/">Back Home</a>
          <a href="/stats" className={styles.stats}>Check Stats</a>
        </div>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  return {
    status: state.puzzle.game.gameStatus,
    solution: state.puzzle.game.solution,
    correctGuessesCount: state.puzzle.correctGuessesCount,
    incorrectGuessesCount: state.puzzle.incorrectGuessesCount,
  }
}

export default connect(mapStateToProps)(GameSummary)